require('./components/placement_group/placement_group.ts');
require('./components/placement_test_scores_tile/placement_test_scores_tile.ts');
require('./components/test_score_graph/test_score_graph.ts');
require('./modals/placement_test_tile_modal.ts');



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-path-placement/src/core.ts